import { request, METHOD } from '@/utils/request.js'


// 自动模式保存
export function save(data) {
    return request(
      '/h5Mfitness/device/save',
      METHOD.POST,
      data
    )
  }
  // 手动模式保存
export function saveToo(data) {
    return request(
      '/h5Mfitness/device/saveToo',
      METHOD.POST,
      data
    )
  }

  // 列表
  export function getFlowableSchoolCorxInfoList(data) {
    return request(
      '/h5Mfitness/device/getFlowableSchoolCorxInfoList',
      METHOD.POST,
      data
    )
  }
    // 列表
    export function getFlowableSchoolCorxInfoTimeList(data) {
      return request(
        '/h5Mfitness/device/getFlowableSchoolCorxInfoTimeList',
        METHOD.POST,
        data
      )
    }
